import { render, staticRenderFns } from "./ClickableDeviceItem.vue?vue&type=template&id=3847f8ec&"
import script from "./ClickableDeviceItem.vue?vue&type=script&lang=ts&"
export * from "./ClickableDeviceItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports